// Validation utility functions
export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const validateGhanaPhone = (phone) => {
    // Accepts formats: 0200000000, +233200000000
    const phoneRegex = /^(\+233|0)[0-9]{9}$/;
    return phoneRegex.test(phone);
};

export const validateGhanaPost = (postCode) => {
    // Ghana Post format: GM-000-0000
    const postRegex = /^GM-\d{3}-\d{4}$/;
    return postCode === '' || postRegex.test(postCode);
};

export const validateRequired = (value) => {
    return value && value.trim().length > 0;
};

export const validateName = (name) => {
    // Allows letters, spaces, and basic punctuation
    const nameRegex = /^[a-zA-Z\s\-'.]+$/;
    return nameRegex.test(name);
};

export const validateAddress = (address) => {
    // Allows letters, numbers, spaces, and common address characters
    const addressRegex = /^[a-zA-Z0-9\s\-.,#]+$/;
    return addressRegex.test(address);
};

export const validateCity = (city) => {
    // Allows letters, spaces, and basic punctuation
    const cityRegex = /^[a-zA-Z\s\-'.]+$/;
    return cityRegex.test(city);
};

export const validateTown = (town) => {
    // Allows letters, spaces, and basic punctuation
    const townRegex = /^[a-zA-Z\s\-'.]+$/;
    return townRegex.test(town);
}; 